import React from 'react';
import './KpiRow.css';

/**
 * KpiRow – horizontal strip of KPI figures
 * @param {Array} items - [{ value, label }]
 */
export default function KpiRow({ items }) {
  return (
    <div className="kpi-row">
      {items.map((item) => (
        <div className="kpi-row__item" key={item.label}>
          <div className="kpi-row__value">{item.value}</div>
          <div className="kpi-row__label">{item.label}</div>
        </div>
      ))}
    </div>
  );
}
